module.exports = __webpack_public_path__ + "d320c338119d67f417ffa3139cee4573.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/yellow_eradicated.png
 ** module id = 1081
 ** module chunks = 0
 **/